import * as React from "react";
import { useState } from "react";
import { UserClaim } from "../../../../../Wrap/Constants/Enums/UserClaim";
import { CustomerSearchModel } from "../../../../../Wrap/Models/Models/Customer/CustomerSearch/CustomerSearchModel";
import { OrganisationSearchModel } from "../../../../../Wrap/Models/Models/Customer/OrganisationSearch/OrganisationSearchModel";
import { AccountSearchModel } from "../../../../../Wrap/Models/Models/Transformation/Account/AccountSearchModel";
import CoachMarker from "../../../../Shared/CoachMarkers/CoachMarker";
import { CoachMarkerContext } from "../../../../Shared/CoachMarkers/CoachMarkerContext";
import { Alert } from "../../../../Shared/Components/Alert";
import { AlertType } from "../../../../Shared/Entities/Constants/AlertConstants";
import { Permission } from "../../../../Shared/Permission/Permission";
import { getQueryParameters } from "../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { AccountSearchAction, IBasicSearchQuery } from "./Action/AccountSearchAction";
import { CustomerSearchAction, ICustomerSearchQuery } from "./Action/CustomerSearchAction";
import { IOrganisationSearchQuery, OrganisationSearchAction } from "./Action/OrganisationSearchAction";
import { ClientQuickSearch } from "./Component/ClientQuickSearch";
import { ClientSearchResultTable } from "./Component/ClientSearchResultTable";
import { clientSearchCoachmarkerConfig, clientTypeEnum } from "./Resource/Content";
import { UserStore } from "../../../Stroes/Variable";
import { JsonDateParser } from "../../../../../react-core/Utils/JsonDateParser";
import AdviserSiteTagManager from "../../../../Shared/Cookies/ChoicesCookie/AdviserSiteTagManager";
import { AccountSearchPanel } from "./Component/AccountSearchPanel";

// will used to replace the current account search page
export const CustomerSearch = () => {
    const [data, setData] = useState<CustomerSearchModel | OrganisationSearchModel | AccountSearchModel>(null);
    const [isSearching, setIsSearching] = useState(false);
    const [clientType, setClientType] = useState(clientTypeEnum.Individual);
    const [query, setQuery] = useState(null);
    const [curPage, setCurPage] = useState(1);
    const showWarningMsg = getQueryParameters()["noresult"] == "true";

    const { setPageConfig } = React.useContext(CoachMarkerContext);

    React.useEffect(() => {
        //setPageConfig(clientSearchCoachmarkerConfig);

        return () => {
            setPageConfig(null);
        };
    }, []);

    React.useEffect(() => {
        setData(null);
    }, [clientType]);

    React.useEffect(() => {
        addEvent({
            environment: {
                appType: "web",
                setting: "prod",
                timestamps: JsonDateParser.toJsonDateNoOffset(new Date()).toString(),
            },
            page: {
                pageUrl: window.location.pathname,
                pageTitle: `${document.title} - customer`,
            },
            user: {
                loginId: UserStore.getUserInfo()?.ClientId.toString(),
                internal: "yes",
            },
            event: "pageLoaded",
        });
    }, []);
    const { addEvent } = new AdviserSiteTagManager();

    const search = (
        clientTypeQuery: clientTypeEnum,
        query: IOrganisationSearchQuery | ICustomerSearchQuery | IBasicSearchQuery,
        pageIndex: number,
        pageSize: number
    ) => {
        setClientType(clientTypeQuery);
        setQuery(query);
        setCurPage(pageIndex);
        setIsSearching(true);
        if (clientTypeQuery == clientTypeEnum.Individual) {
            CustomerSearchAction.searchCustomers(
                query as ICustomerSearchQuery,
                pageIndex,
                pageSize,
                (res: CustomerSearchModel) => {
                    setData(res);
                    setIsSearching(false);
                }
            );
        } else if (clientTypeQuery == clientTypeEnum.Organisation) {
            OrganisationSearchAction.searchOrganisations(
                query as IOrganisationSearchQuery,
                pageIndex,
                pageSize,
                (res: OrganisationSearchModel) => {
                    setData(res);
                    setIsSearching(false);
                }
            );
        } else if (clientTypeQuery == clientTypeEnum.Consolidated) {
            AccountSearchAction.searchAccounts(
                query as IBasicSearchQuery,
                pageIndex,
                pageSize,
                (res: AccountSearchModel) => {
                    setData(res);
                    setIsSearching(false);
                }
            );
        }
    };

    return (
        <Permission userClaim={UserClaim.AdviserPortalAccountSearchCanView}>
            <div role="main" id="main">
                <h1>What do you want to search for?</h1>
                <hr />
                <div className="row mb-40">
                    <div className="col-fluid">
                    <CoachMarker coachMarkerKey="client-search-criteria" />
                        <CoachMarker coachMarkerKey="client-search-advanced" />
                        <button
                            className={`btn square ${clientType === clientTypeEnum.Individual ? "primary" : "secondary"}`}
                            onClick={() => {
                            setClientType(clientTypeEnum.Individual);
                        }}
                        >
                        Clients
                        </button>
                        <button
                            className={`btn square ${
                                clientType === clientTypeEnum.Organisation ? "primary" : "secondary"
                            } ml-10`}
                            onClick={() => setClientType(clientTypeEnum.Organisation)}
                        >
                        Organisation
                        </button>
                        <button
                            className={`btn square ${
                                clientType === clientTypeEnum.Consolidated ? "primary" : "secondary"
                        } ml-10`}
                        onClick={() => setClientType(clientTypeEnum.Consolidated)}
                        >
                        Consolidated
                        </button>

                    </div>
                    <div className="col-auto col-right">
                        <div className="advanced-query">
                            <button className="trigger" onClick={() => {setClientType(clientTypeEnum.AdvancedSerach);}}>
                                <span className="icon" aria-hidden={true} />
                                Advanced search
                            </button>
                        </div>
                    </div>
                </div>          
                <div>
                    <div className="module pb-0">
                        {clientType == clientTypeEnum.AdvancedSerach ? (
                            <AccountSearchPanel />
                        ) : (
                            <ClientQuickSearch
                                isSearching={isSearching}
                                clientType={clientType}
                                onSearch={(query) => {
                                    search(clientType, query, 1, 20);
                                }}
                                cssWrapper={"mb-0"}
                            />
                        )}

                        <br />
                        {showWarningMsg && (
                            <Alert
                                alertType={AlertType.Warning}
                                message={
                                    "Client not found. Please try again. Type in the client's NAME or ACCOUNT NUMBER in the box below & press Search."
                                }
                            />
                        )}
                    </div>
                    <ClientSearchResultTable
                        data={data}
                        onPageChange={(pageIndex, pageSize) => {
                            search(clientType, query, pageIndex, pageSize);
                        }}
                        isSearching={isSearching}
                        clientType={clientType}
                        currentPage={curPage}
                    />
                </div>
            </div>
        </Permission>
    );
};
